import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { createContact, deleteContact, fetchAllContacts } from './contactAPI';

const initialState = {
  contacts: [],
  status: 'idle',
  currentContact: null,
  totalContacts: 0
};
//we may need more info of current order

export const createContactAsync = createAsyncThunk(
  'order/createContact',
  async (contact) => {
    const response = await createContact(contact);
    // The value we return becomes the `fulfilled` action payload
    return response.data;
  }
);

export const fetchAllContactsAsync = createAsyncThunk(
    'order/fetchAllContacts',
    async ({sort, pagination}) => {
      const response = await fetchAllContacts(sort,pagination);
      // The value we return becomes the `fulfilled` action payload
      return response.data;
    }
  );

  export const deleteContactAsync = createAsyncThunk(
    "user/deleteContact",
    async (id) => {
      const response = await deleteContact(id);
      // The value we return becomes the `fulfilled` action payload
      return response.data;
    }
  );



export const contactSlice = createSlice({
  name: 'contact',
  initialState,
  reducers: {
    resetContact: (state) => {
      state.currentContact = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createContactAsync.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(createContactAsync.fulfilled, (state, action) => {
        state.status = 'idle';
        state.contacts.push(action.payload);
        state.currentContact = action.payload;
      })
      .addCase(fetchAllContactsAsync.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchAllContactsAsync.fulfilled, (state, action) => {
        state.status = 'idle';
        state.contacts = action.payload.contacts;
        state.totalContacts = action.payload.totalContacts;
      })
      .addCase(deleteContactAsync.pending, (state) => {
        state.status = "loading";
      })
      .addCase(deleteContactAsync.fulfilled, (state, action) => {
        state.status = "idle";
        // Assuming action.payload contains the ID of the deleted user
        const deletedContactId = action.payload;

        // Filter out the deleted user from state.allUsers array
        const updatedAllContacts = state.contacts.filter(
          (contact) => contact.id !== deletedContactId
        );
        state.contacts = updatedAllContacts;
        state.totalContacts = state.totalContacts - 1;
      });
  },
});

export const { resetOrder } = contactSlice.actions;

export const selectContacts = (state) => state.contact.contacts;
export const selectTotalContacts = (state) => state.contact.totalContacts;

export default contactSlice.reducer;
